import { Box, Card, Grid, Modal, Typography } from "@mui/material";
import MDButton from "components/MDButton";
import React from "react";
import HelpIcon from "@mui/icons-material/Help";
import CheckIcon from "@mui/icons-material/Check";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  display: "grid",
  justifyContent: "center",
};
function RouteModal({ ...props }) {
  return (
    <Modal
      open={props.open}
      // onClose={props.closeModalClick}
      disableEscapeKeyDown
      onClose={(event, reason) => {
        if (reason === "backdropClick") return; // 🚫 prevent outside click close
        props.closeModalClick(event, reason);
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Card sx={style}>
        <Box>
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            style={{ fontSize: "40px", textAlign: "center" }}
          >
            <CheckIcon style={{ color: "green" }} />
          </Typography>
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            style={{ color: "black" }}
          >
            {props.heading ? props.heading : ""}
          </Typography>
          <Grid
            container
            id="modal-modal-description"
            sx={{ mt: 2, justifyContent: "center" }}
          >
            {/* <MDButton className="modalButton no-button" onClick={props.handleCancel} sx={{ textTransform: "capitalize" }}>
              No
            </MDButton> */}
            &nbsp; &nbsp;
            <MDButton
              className="modalButton no-button"
              onClick={props.handleRoute}
              sx={{ textTransform: "capitalize" }}
            >
              Ok
            </MDButton>
          </Grid>
        </Box>
      </Card>
    </Modal>
  );
}

export default RouteModal;
